const routes = [
  {
    path: 'user',
    component: () => import('@/views/User.vue'),
    children: [
      {
        path: '/user',
        name: 'user',
        component: () => import('@/views/user/Menu.vue'),
      },
    ],
  },
];

export default routes;
